// frontend/src/components/MlExperiment/MlExperimentStats.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const MlExperimentStats: React.FC<Props> = ({ analysis }) => {
  const stats = [
    { icon: '📊', value: renderValue(analysis.dataset_name), label: 'Dataset' },
    { icon: '🎯', value: renderValue(analysis.problem_type), label: 'Problema' },
    { icon: '📈', value: renderValue(analysis.strategy_name), label: 'Estratégia' },
    { icon: '📊', value: renderValue(analysis.metric_value), label: renderValue(analysis.metric_name) },
  ];

  return (
    <>
      <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #1a4a7a' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#e0e0e0' }}>
          {renderValue(analysis.dataset_name)}
        </div>
        <div style={{ fontSize: '11px', color: '#8899aa', fontFamily: 'monospace', marginTop: '2px' }}>
          trace_id: {renderValue(analysis.trace_id)}
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '24px'
      }}>
        {stats.map((stat, index) => (
          <div
            key={index}
            style={{
              background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
              borderRadius: '12px',
              padding: '16px',
              border: '1px solid #1a4a7a',
              textAlign: 'center'
            }}
          >
            <div style={{ fontSize: '28px', display: 'block', marginBottom: '4px' }}>
              {stat.icon}
            </div>
            <div style={{ fontSize: '16px', fontWeight: 600, color: '#4fc3f7' }}>
              {stat.value}
            </div>
            <div style={{ fontSize: '13px', color: '#8899aa' }}>
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};